import React, { ReactNode } from 'react';

export interface ErrorProps {
  icon: ReactNode;
  title: string | undefined;
  description: string;
}

const Error = ({ icon, title, description }: ErrorProps) => {
  return (
    <>
      <div className="flex flex-col items-center justify-center w-full h-full mb-10">
        <span className="mb-12">{icon}</span>
        {title && (
          <span
            className="font-semibold text-[24px] mt-12 text-gray-8 text-center"
            dangerouslySetInnerHTML={{ __html: title }}
          ></span>
        )}
        <span
          className="text-gray-7 text-[18px] leading-[25px] mt-5 break-keep text-center"
          dangerouslySetInnerHTML={{ __html: description }}
        ></span>
      </div>
    </>
  );
};

export default Error;
